import { useAppSelector } from '@shared/model';
import { selectIsAuth } from '@entities/user';
import { LoginButton, LogoutButton } from './components';
import { contentContainerStyle, logotypeStyle, wrapperStyle } from './Header.tailwind';

const Header = () => {
  const isAuth = useAppSelector(selectIsAuth);

  return (
    <div className={wrapperStyle}>
      <div className={contentContainerStyle}>
        <h4 className={logotypeStyle}>Finance Legal</h4>
        {isAuth ? <LogoutButton /> : <LoginButton />}
      </div>
    </div>
  );
};

export default Header;
